import React, {Component} from 'react';
import Bizzerd from "./Bizzerd";
import PropTypes from 'prop-types'
import {getBizzerdById, getBizzerdByPersonId} from '../../actions/bizzerdActions';
import {getPersonById, getPersonByUser, getVcardByPerson} from '../../actions/personActions';
import {addStat} from '../../actions/statsActions';
import {connect} from 'react-redux';
import isEmpty from './../../validation/is-empty';
import {PlaceholderPerson} from "../common/PlaceholderPerson";
import {getTranslation} from "../../actions/translationActions";
import phoneMockup from '../../assets/img/phoneMockupEmpty.png';
import SubTitle from "../common2/fields/text/subtitle.text";
import {getTemplateById} from "../../actions/templateActions";


class DisplayBizzerd extends Component {

    componentDidMount() {
        if (this.props.templateId !== undefined) {
            this.props.getTemplateById(this.props.templateId);
            this.setState({
                person: this.props.personContent,
                placeholder: false
            })
            return
        }
        //Load from ID in URL
        else if (this.props.match !== undefined) {
            this.props.getBizzerdByPersonId(this.props.match.params.id);
            this.props.getPersonById(this.props.match.params.id);
        }
        //Load from personID in props
        else if (this.props.personId !== undefined) {

            this.props.getBizzerdByPersonId(this.props.personId);
            this.props.getPersonById(this.props.personId);
            if (this.props.personId && false)
                this.props.getTranslation(this.props.personId)

        }
        //Load from BizzerdID in Props with Placeholder content
        else if (this.props.bizzerdId !== undefined) {
            this.props.getBizzerdById(this.props.bizzerdId);
            if (this.props.personContent === undefined) {
                this.setState({
                    person: PlaceholderPerson,
                    placeholder: true
                })
            } else {
                if (this.props.personContent && this.props.personContent._id && false)
                    this.props.getTranslation(this.props.personContent._id)
                this.setState({
                    person: this.props.personContent,
                    placeholder: false
                })
            }
        }
        //Bizzerd in Props either with or without person.
        else if (this.props.bizzerdLayout !== undefined) {
            if (this.props.personContent === undefined) {
                this.setState({
                    bizzerd: this.props.bizzerdLayout,
                });
                // this.props.getPersonByUser();

            } else {
                if (this.props.personContent && this.props.personContent._id && false) {
                    this.props.getTranslation(this.props.personContent._id)
                    // console.log("Get translation 1")
                    // console.log(this.props.personContent)
                }
                this.setState({
                    bizzerd: this.props.bizzerdLayout,
                    person: this.props.personContent
                });
            }
        }
        if (this.props.phoneBackDrop) {
            this.setState({phoneBackDrop: true})
        }
    }

    loadVcard = (nextProps) => {
        this.setState({downloaded: true})
        let res = nextProps.data.data.data;
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.person.fullname + `.vcf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        // console.log(link);
        link.parentNode.removeChild(link);
        if (window.location.href.includes("?vcard=true")) {
            // window.location.href = window.location.href.replace("?vcard=true", "");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.templates && nextProps.templates.template && this.props.templateId === nextProps.templates.template._id && nextProps.templates.template._id !== undefined && nextProps.templates.template._id !== this.state.bizzerd._id) {
            let template = nextProps.templates.template
            template.shape = template.shape.map(shape => {
                if (shape.type === "photo") {
                    shape.objectFit = "cover"
                }
                return shape
            })
            if (this.props.logo) {
                const all_logos_png = ["http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png", 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653175086/wxqmwhfgyvnod5bh6lvd.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654891230/h1nesgiirnz2v2qrred8.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654974174/xvrq9nq2871sg05om6bk.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654699774/gnqujrrenohz6ksdderx.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654971769/fdz3lwnyuryhfimscxqy.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png']
                const all_logos_svg = ['https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651317700/gyvmrdz1vwg7ufzpvbva.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651843579/ffl4mswrkuonlodk4bfn.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1652814758/vkdnxqopwi3mfgalvrwf.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1658781888/z27q1sprygdof0aal1bm.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700006/cs0bxifmqtm5psxyxnmp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg']

                template.image = template.image.map(image => {
                    if (image.logo) {
                        image.image = this.props.logo
                        image.objectFit = "contain"
                    }
                    if (all_logos_svg.includes(image.image) || all_logos_png.includes(image.image)) {
                        image.image = this.props.logo
                        image.objectFit = "contain"
                    }
                    return image
                })
            }
            this.setState({bizzerd: template})
            return
        }
        if (nextProps.logo !== this.props.logo) {
            let template = this.state.bizzerd
            const all_logos_png = ["http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654972713/pdmpbrpwavvpszf2zpst.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654973153/mpm1au0jxgch3jzocpqv.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618932/vusysqorbca8qcpdo8lj.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650629254/veipxjed1tgq0emtylmf.png", "http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png", 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653172119/l1s4dgbwkath7luyfqc2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653164845/kcxflro4cbifpqj2l2qe.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653168424/ozibmi9hc3jl3goj6bt2.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653175086/wxqmwhfgyvnod5bh6lvd.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651852499/ld2ichkzv0fmnlqxtiff.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1651851849/sk58lbvhkgusxb4pr3qs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653173165/qmpyv9nlog9nguynf9gv.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654683262/eveak8bvrqclnvc45utp.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654701629/b9sgvhnfoisetwbubhir.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654891230/h1nesgiirnz2v2qrred8.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1654974174/xvrq9nq2871sg05om6bk.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654892073/xg752ftsm69gdl28jgo7.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650618448/qqrsosvqxlxb6icp6weu.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651846978/evjva9lep41wmrpkub2v.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653169896/qqbfc2mktb6pgzcf1o9d.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654699774/gnqujrrenohz6ksdderx.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700144/pgbyikl6losmr8xa4dzs.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654971769/fdz3lwnyuryhfimscxqy.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651245762/eijjkx7noepn0i7nntq6.png', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1653163205/dcumbpufb7cwuadvezaf.png', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1653176009/f7tzfl7acrej0gycydam.png']
            const all_logos_svg = ['https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541998/afjefnueknwmvze7ujqa.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651317700/gyvmrdz1vwg7ufzpvbva.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1651843579/ffl4mswrkuonlodk4bfn.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1652814758/vkdnxqopwi3mfgalvrwf.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1658781888/z27q1sprygdof0aal1bm.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656542236/lofw8wp4ypojthn1cxdg.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1650626295/nelkqvhpwmj4pgprutzh.svg', 'http://res.cloudinary.com/bizzerd-b-v/image/upload/v1654700006/cs0bxifmqtm5psxyxnmp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541440/jtgkn2brh0sqwhm7gfzp.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1656541431/bxrrtqg4iaimcanji3wd.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg', 'https://res.cloudinary.com/bizzerd-b-v/image/upload/v1657308882/zl1vdcxzv8y9kybmhkyo.svg']

            template.image = template.image.map(image => {
                if (image.logo) {
                    image.image = nextProps.logo
                    image.objectFit = "contain"
                }
                if (all_logos_svg.includes(image.image) || all_logos_png.includes(image.image)) {
                    image.image = nextProps.logo
                    image.objectFit = "contain"
                }
                return image
            })
            this.setState({bizzerd: template})
        }
        if (nextProps.personContent && this.props.personContent && nextProps.personContent.pasfoto !== this.props.personContent.pasfoto) {
            this.setState({personContent: nextProps.personContent})
        }
        if (nextProps.templateId !== this.props.templateId) {
            this.props.getTemplateById(nextProps.templateId);
        }
        if (nextProps.personContent !== this.state.person) {
            this.setState({
                person: nextProps.personContent
            })
            if (nextProps.personContent && nextProps.personContent._id && false) {
                this.props.getTranslation(nextProps.personContent._id)
            }
        }
        if (this.props.templateId) {
            return
        }
        if (nextProps.stats && nextProps.stats.success) {
            this.changeStatStatus()
        }
        if (window.location.href.includes("?vcard=true", 0) && this.state.person._id && !nextProps.data.data.status) {
            this.props.getVcardByPerson(this.state.person._id);
        }
        if (nextProps.data && nextProps.data.data && nextProps.data.data.status && this.state.person._id && window.location.href.includes("?vcard=true", 0) && !this.state.downloaded) {
            this.loadVcard(nextProps)
        }
        if (nextProps.personContent !== this.state.person) {
            this.setState({
                person: nextProps.personContent
            })
            if (nextProps.personContent && nextProps.personContent._id && false) {
                this.props.getTranslation(nextProps.personContent._id)
            }
        }
        if (nextProps.bizzerd !== undefined && this.props.bizzerdLayout === undefined) {
            if (nextProps.bizzerd.bizzerd !== this.state.bizzerd) {
                this.setState({
                    bizzerd: nextProps.bizzerd.bizzerd
                })
            }
        }

        if (nextProps.bizzerdId !== this.props.bizzerdId) {
            this.props.getBizzerdById(nextProps.bizzerdId);
        }

        if (nextProps.person !== undefined && this.props.personContent === undefined && !this.state.placeholder) {
            this.setState({
                person: nextProps.person.person
            })
            if (nextProps.personContent && nextProps.personContent._id && false) {
                this.props.getTranslation(nextProps.personContent._id)
            }

        } else if (nextProps.bizzerdLayout !== undefined) {
            if (nextProps.personContent === undefined) {
                this.setState({
                    bizzerd: nextProps.bizzerdLayout,
                    person: PlaceholderPerson,
                    placeholder: true
                });
            } else {
                this.setState({
                    bizzerd: nextProps.bizzerdLayout,
                    person: nextProps.personContent
                });
            }
        }
        if (nextProps.translations) {
            this.setState({translations: nextProps.translations.translations})
        }
    };

    constructor(props) {
        super(props);
        this.state =
            {
                downloaded: false,
                bizzerd: {},
                didStats: false,
                person: {
                    firstname: 'Voornaam',
                    lastname: 'Achternaam',
                    jobtitle: 'Functie Titel',
                    tel: '+31 (06)123 45 678',
                    email: 'voornaam@bizzerd.com',
                    address: 'Plaatsnaam: Straatnaam 1',
                    website: 'https://www.bizzerd.com',
                    mobile: '+31 (06)123 45 678',
                },
                placeholder: false,
                translations: [],
                currentTranslation: 0,
                phoneBackDrop: false,
                translationActive: false,
            };
    }

    resize = (value) => {

        let realWidth = 640;
        if (this.props.realWidth !== undefined) {
            realWidth = this.props.realWidth;
        }
        return value * realWidth / 640;
    };

    changeStatStatus = () => {
        this.setState({didStats: true})
    }


    render() {
        const {bizzerd, person, translations} = this.state;
        let bizzerdDisplay;
        if (isEmpty(bizzerd)) {
            bizzerdDisplay = <SubTitle text={"Loading..."}/>
        } else {
            if (this.props.personContent) {
                if (!this.props.personContent.pasfoto && !this.props.personContent.base64pasfoto) {
                    if (this.props.bizzerdLayout) {
                        this.props.bizzerdLayout.shape.forEach(shape => {
                            if (shape.type === "photo") {
                                shape.height = 0;
                                shape.width = 0;
                            }
                        })
                    }
                }
            }
            let showShadow = true;
            if (this.props.shouldShowShadow === false) {
                showShadow = false;
            }
            if (this.state.phoneBackDrop) {

                bizzerdDisplay = <>

                    <Bizzerd shouldShowShadow={showShadow} shouldBeClickable={this.props.shouldBeClickable}
                             style={{display: 'inline-block'}}
                             bizzerdLayout={bizzerd} resize={this.resize}
                             personContent={person} translations={translations} vcard={this.vcard}/>
                    <img id={"phone"} style={{
                        display: "block",
                        position: "absolute",
                        left: "-20px",
                        top: "-80px",
                        width: this.props.realWidth + 40 + "px",
                        height: this.resize(bizzerd.background[0].height) + 150 + "px"
                    }} src={phoneMockup}/></>
            } else
                bizzerdDisplay =
                    <Bizzerd shouldShowShadow={showShadow} shouldBeClickable={this.props.shouldBeClickable}
                             style={{display: 'inline-block'}} onSelectField={this.props.onSelectField}
                             changeTranslation={this.props.changeTranslation}
                             bizzerdLayout={bizzerd} resize={this.resize}
                             personContent={person} translations={translations} vcard={this.vcard}/>;
            if (!this.state.didStats && this.props.shouldBeClickable) {
                this.props.addStat(person, window.location.href)
            }


        }
        return (
            <div id={bizzerd ? bizzerd._id : 'myBizzerdBlock'}
                 style={{cursor: typeof this.props.onClick === "function" ? "pointer" : "default"}}
                 onClick={this.props.onClick}>
                {bizzerdDisplay}
            </div>
        )
    }
}

DisplayBizzerd.propTypes = {
    bizzerd: PropTypes.object.isRequired,
    person: PropTypes.object.isRequired,
    getBizzerdByPersonId: PropTypes.func.isRequired,
    getPersonByUser: PropTypes.func.isRequired,
    getPersonById: PropTypes.func.isRequired,
    getVcardByPerson: PropTypes.func.isRequired,
    getBizzerdById: PropTypes.func.isRequired,
    getTemplateById: PropTypes.func.isRequired,
    onSelectField: PropTypes.func,
    logo: PropTypes.string,
    addStat: PropTypes.func.isRequired,
    personId: PropTypes.number,
    realWidth: PropTypes.number,
    bizzerdId: PropTypes.string,
    templateId: PropTypes.string,
    bizzerdLayout: PropTypes.object,
    personContent: PropTypes.object,
    translations: PropTypes.object,
    shouldBeClickable: PropTypes.bool,
    shouldShowShadow: PropTypes.bool,
    onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
    bizzerd: state.bizzerd,
    data: state.data,
    person: state.persons,
    template: state.template,
    templates: state.templates,
    stats: state.stats,
    translations: state.translations
});

export default connect(mapStateToProps, {
    getBizzerdById,
    addStat,
    getBizzerdByPersonId,
    getPersonById,
    getPersonByUser,
    getTemplateById,
    getVcardByPerson,
    getTranslation,
})(DisplayBizzerd);
